import { render } from "./ConfirmAction.vue?vue&type=template&id=5c3e6c7e"
import script from "./ConfirmAction.vue?vue&type=script&lang=js"
export * from "./ConfirmAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__